<template>
  <div id="hit-leaf-small" v-bind:style="{'background-color': survey.badge.bg, 'border-color': survey.badge.accent}">

    <div class="hit-title" v-bind:style="{'background-color': survey.badge.pluscolor}">
      <div v-bind:style="{color: survey.badge.text}">{{ survey.name }}</div>

      <div class="hit-stars"><hit_stars :stars="survey.all_percent" v-bind:style="{'color': survey.badge.accent}" /></div>
    </div>

    <div class="hit-top-stars" v-if="survey.all" v-bind:style="{color: survey.badge.text}">
      <div v-bind:style="{'color': survey.badge.accent}">{{ survey.all_percent }}</div><div>von 5<br>Sternen</div>
    </div>

    <div class="hit-top-stars" v-if="!survey.all" v-bind:style="{color: survey.badge.text}">{{ $tc("message.noEntry", survey.all) }}</div>

    <div class="hit-logo" v-bind:style="{'background-color': survey.badge.pluscolor}">

      <div class="hit-votes" v-bind:style="{color: survey.badge.text}"><i class="hit-glyphicon hit-glyphicon-user"></i> {{ survey.all }} Bewertungen</div>
      <div class="hit-validated" v-if="survey.all" v-bind:style="{color: survey.badge.text}">{{ $t("message.validation") }}: 100%</div>

    </div>

    <a href="https://hitklick.com" target="_blank" class="hit-url" v-bind:style="{'color': survey.badge.pluscolor, 'background-color': survey.badge.accent}"><b>hitklick</b>.com</a>

  </div>
</template>

<script>

export default{

  name: 'roundet_small',
  props: { survey: Object },

  computed: {

    stars_reverse: function () {
      var rev = JSON.parse(JSON.stringify(this.stars))

      return rev.reverse()
    }

  },
  methods: {

    get_width: function (star) {
      if (!this.survey.percent[star]) { return {} }

      const width = (this.survey.percent[star] / 100) * 150

      return {width: width + 'px'}
    },

    get_avg_star_class: function (key) {
      if (Number.isInteger(this.survey.all_percent) == false && (key - this.survey.all_percent) < 1 && key > this.survey.all_percent) { return {'hit-glyphicon-star-half': true} } else if (key <= this.survey.all_percent) { return {'hit-glyphicon-star': true} } else { return {'hit-glyphicon-star-empty': true} }
    }
  }

}

</script>

<style scoped>

#hit-leaf-small{
  text-align: center;
  width: 230px;
  display: inline-block;

  font-family: Arial;
  font-size: 12pt;
  overflow: hidden;

  border-top-left-radius: 10px;
  border-bottom-right-radius: 10px;
  background-color: lightgrey;

  border: 1px solid darkgrey;
  box-shadow: 0px 10px 15px -10px rgba(0,0,0,0.6);
}

#hit-leaf-small .hit-title, #hit-leaf-small .hit-logo{
  margin-top: 0px;
  margin-bottom: 10px;
  padding: 5px 5px;
  font-size: 14px;
  line-height: 0.9em;
  background-color: white;
  margin: 10px;
  box-sizing: border-box;

  border-top-left-radius: 10px;
}

#hit-leaf-small .hit-logo{

  border-top-left-radius: 0px;
  border-bottom-right-radius: 0px;

}

#hit-leaf-small .hit-votes{

}

#hit-leaf-small .hit-top-stars div:first-of-type{
  font-size: 28pt;
  font-weight: bold;
  width: 50%;
  text-align: right;
  display: inline-block;
  padding-right: 10px;
  box-sizing: border-box;

}

#hit-leaf-small .hit-top-stars div:nth-of-type(2){
  font-size: 14pt;
  width: 50%;
  font-weight: normal;
  text-align: left;
  display: inline-block;
  box-sizing: border-box;
}

#hit-leaf-small .hit-stars{
  margin: 10px 0;
  font-size: 28pt;
}

#hit-leaf-small .hit-proz-stars, #hit-leaf-small .hit-proz-avg{
  font-size: 10pt;
  padding-top: 2px;
}

#hit-leaf-small .hit-proz-avg{
  font-weight: bold;
}

#hit-leaf-small .hit-validated{
  font-size: 10px;
  margin-top: 10px;
}

#hit-leaf-small .hit-url{
  text-align: center;
  font-size: 9px;

  text-decoration: none;
  background-color: #717c80;
  display: block;
  padding: 5px;
  color: white;
}
</style>
